__turbopack_context__.v({
  "buySection": "tHv7jG_buySection",
  "desktopPrimaryOffers": "tHv7jG_desktopPrimaryOffers",
  "disclaimerButton": "tHv7jG_disclaimerButton",
  "disclaimerButtonContainer": "tHv7jG_disclaimerButtonContainer",
  "heightOpacityIn": "tHv7jG_heightOpacityIn",
  "largePrompt": "tHv7jG_largePrompt",
  "learnMoreButton": "tHv7jG_learnMoreButton",
  "leftPanel": "tHv7jG_leftPanel",
  "limitedEditionBanner": "tHv7jG_limitedEditionBanner",
  "mobileCarouselSection": "tHv7jG_mobileCarouselSection",
  "mobilePrimaryOffers": "tHv7jG_mobilePrimaryOffers",
  "notServicableMessageContainer": "tHv7jG_notServicableMessageContainer",
  "outOfStockBanner": "tHv7jG_outOfStockBanner",
  "powerPlugSubsection": "tHv7jG_powerPlugSubsection",
  "priceContentContainer": "tHv7jG_priceContentContainer",
  "rightPanel": "tHv7jG_rightPanel",
  "root": "tHv7jG_root",
  "section": "tHv7jG_section",
  "separator": "tHv7jG_separator",
  "sizeInfoModal": "tHv7jG_sizeInfoModal",
  "stickyPanel": "tHv7jG_stickyPanel",
});
